export class ObjectHelper {
	static deepCopyObject(obj: any) {
		return JSON.parse(JSON.stringify(obj));
	}
}